<!-- Presentational "subscription started" chat status card: green-toned sparkles badge beside the caption/title/subtitle. Data loading lives in the app views via useChatSubscriptionStart. -->

<script lang="ts" setup>
import { Sparkles } from 'lucide-vue-next';

import ChatStatusCard from './ChatStatusCard.vue';

// Props
defineProps<{
  /** Localised caption, e.g. "Subscription started" — kept in the consumer so copy can stay per-app. */
  caption: string;
  /** Product name; ignored while `loading`. */
  title: string;
  /** Formatted "price · renews date" line, hidden when null/empty. */
  subtitle?: string | null;
  /** Explicit loading signal (e.g. `!vm.loaded`) — renders a skeleton instead of inferring from empty data. */
  loading?: boolean;
}>();
</script>

<template>
  <ChatStatusCard
    tone="green"
    :caption="caption"
    :title="title"
    :loading="loading"
  >
    <template #media>
      <div :class="css.badge">
        <Sparkles :class="css.icon" />
      </div>
    </template>

    <template
      v-if="subtitle"
      #subtitle
    >
      {{ subtitle }}
    </template>
  </ChatStatusCard>
</template>

<style lang="scss" module="css">
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: $color-green-100;
}

.icon {
  width: 22px;
  height: 22px;
  color: $color-green-500;
}
</style>
